import titleCaseCompanyName from "./titleCaseCompanyName";

export const ADMIN_SUBDOMAIN = "app";
export const ADMINISTRATE_PATH = "/admin";
export const ADMINISTRATE_LABEL = "Administrate";
export const WORKSPACE_TINT = "#E3F4F8";
export const WORKSPACE_TINT_HOVER = "#D4EBF2";

export function isAdministrateWorkspace(workspace) {
  return workspace?.isAdministrate === true || workspace?.subdomain === ADMIN_SUBDOMAIN;
}

export function workspaceLabel(workspace) {
  if (isAdministrateWorkspace(workspace)) return ADMINISTRATE_LABEL;
  return workspace?.vendorName?.trim() || titleCaseCompanyName(workspace?.name);
}

export function sortWorkspaces(workspaces) {
  return [...workspaces].sort((left, right) => {
    if (isAdministrateWorkspace(left) !== isAdministrateWorkspace(right)) {
      return isAdministrateWorkspace(left) ? 1 : -1;
    }

    return workspaceLabel(left).localeCompare(workspaceLabel(right), undefined, { sensitivity: "base" });
  });
}

export function workspaceSecondary(workspace) {
  if (isAdministrateWorkspace(workspace)) return "Admin dashboard";
  return workspace?.assignedWarehouseLocation || "";
}
